/**
 * Environment Configuration Helper for React
 * Automatically detects and configures API URLs based on environment
 */

// Detect if we're in development or production
const isDevelopment = process.env.NODE_ENV === 'development';
const isProduction = process.env.NODE_ENV === 'production';

// Get API URL dynamically
const getApiUrl = () => {
  // Runtime override - check localStorage first (for debugging)
  if (typeof window !== 'undefined') {
    const overrideUrl = localStorage.getItem('API_URL_OVERRIDE');
    if (overrideUrl) {
      console.warn('⚠️ Using API URL override from localStorage:', overrideUrl);
      return overrideUrl;
    }
  }

  // Check if we're running in development mode (React dev server)
  // In development, React sets NODE_ENV to 'development'
  if (isDevelopment) {
    // Always use localhost in development
    return 'http://localhost:5000/api';
  }

  // Runtime detection for production builds
  if (typeof window !== 'undefined') {
    const host = window.location.hostname;
    const protocol = window.location.protocol;
    const port = window.location.port;
    
    // If running on localhost, always use localhost API
    if (host === 'localhost' || host === '127.0.0.1' || host === '0.0.0.0') {
      return 'http://localhost:5000/api';
    }
    
    // If REACT_APP_API_URL was set at build time, use it
    if (process.env.REACT_APP_API_URL) {
      // But only if we're not on localhost
      if (!host.includes('localhost') && !host.includes('127.0.0.1')) {
        return process.env.REACT_APP_API_URL;
      }
    }
    
    // Otherwise, use the same origin (relative path)
    return `${protocol}//${host}${port ? `:${port}` : ''}/api`;
  }

  // Fallback
  return '/api';
};

// Get configuration
const getConfig = () => {
  return {
    isDevelopment,
    isProduction,
    apiUrl: getApiUrl(),
    googleClientId: process.env.REACT_APP_GOOGLE_CLIENT_ID,
    recaptchaSiteKey: process.env.REACT_APP_RECAPTCHA_SITE_KEY,
  };
};

// Log configuration in development or when on localhost
if (typeof window !== 'undefined') {
  const isLocalhost = window.location.hostname === 'localhost' || 
                     window.location.hostname === '127.0.0.1';
  
  if (isDevelopment || isLocalhost) {
    const config = getConfig();
    console.log('🔧 Environment Configuration:', config);
    console.log('🌐 Detected API URL:', config.apiUrl);
    
    // Warn if production build is being used on localhost
    if (!isDevelopment && isLocalhost) {
      console.warn('⚠️ WARNING: You are running a PRODUCTION BUILD on localhost!');
      console.warn('⚠️ For local development, use: npm run dev');
      console.warn('⚠️ Or set override: localStorage.setItem("API_URL_OVERRIDE", "http://localhost:5000/api")');
    }
    
    // Check if API URL is pointing to production when on localhost
    if (isLocalhost && config.apiUrl.includes('mystoryme.finbills.com')) {
      console.error('❌ ERROR: API URL is pointing to PRODUCTION server!');
      console.error('❌ This will not work for local development.');
      console.error('💡 Quick fix: localStorage.setItem("API_URL_OVERRIDE", "http://localhost:5000/api")');
      console.error('💡 Then refresh the page.');
    }
  }
}

export default getConfig();
export { getApiUrl, getConfig, isDevelopment, isProduction };

